import axios from "axios";
import cfg from "@/service/Configurations";

await cfg.initialize();

const routingRuleApi = axios.create({
    baseURL: cfg.getConfiguration('VUE_APP_BACKEND_URL')
});

export default routingRuleApi;